import BooleanInput from 'components/TypedInputs/components/Boolean'
import StringInput from 'components/TypedInputs/components/String'
import TextInput from 'components/TypedInputs/components/Text'
import NumberInput from 'components/TypedInputs/components/Numeric'
import DateInput from 'components/TypedInputs/components/Date'
import NumericInput from 'components/TypedInputs/components/Numeric'

const DATE_BASED_OPERATORS = ['IS_BEFORE', 'IS_AFTER', 'IS_NOT_BEFORE', 'IS_NOT_AFTER', 'BETWEEN']

export const PROPERTY_TYPE_COMPONENT_DEFAULTS = {
  BOOLEAN: BooleanInput,
  DATE: DateInput,
  DATETIME: DateInput,
  STRING: StringInput,
  NUMERIC: NumberInput,
  PLAYBOOK: StringInput,
  EVENT: NumericInput
}

export const PROPERTY_TYPE_COMPONENTS_BY_OPERATOR = {
  IS: {
    BOOLEAN: PROPERTY_TYPE_COMPONENT_DEFAULTS.BOOLEAN
  },
  IS_NOT: {
    BOOLEAN: PROPERTY_TYPE_COMPONENT_DEFAULTS.BOOLEAN
  },
  IS_ANY: {
    BOOLEAN: PROPERTY_TYPE_COMPONENT_DEFAULTS.BOOLEAN,
    DATE: DateInput,
    DATETIME: DateInput,
    STRING: TextInput,
    NUMERIC: TextInput
  },
  IS_NOT_ANY: {
    BOOLEAN: PROPERTY_TYPE_COMPONENT_DEFAULTS.BOOLEAN,
    DATE: DateInput,
    DATETIME: DateInput,
    STRING: TextInput,
    NUMERIC: TextInput
  },
  CONTAINS_EXACT: {
    BOOLEAN: BooleanInput
  },
  DOES_NOT_CONTAIN_EXACT: {
    BOOLEAN: BooleanInput
  },
  STARTS_WITH: {
    BOOLEAN: BooleanInput
  },
  DOES_NOT_START_WITH: {
    BOOLEAN: BooleanInput,
    STRING: StringInput
  },
  ENDS_WITH: {
    BOOLEAN: Text,
    STRING: StringInput
  },
  DOES_NOT_END_WITH: {
    BOOLEAN: Text,
    STRING: StringInput
  },
  IS_PRESENT: {},
  IS_NOT_PRESENT: {},
  GTE: {
    NUMERIC: NumberInput
  },
  LTE: {
    NUMERIC: NumberInput
  },
  GT: {
    NUMERIC: NumberInput
  },
  LT: {
    NUMERIC: NumberInput
  },
  BETWEEN: {
    NUMERIC: NumberInput
  },
  NOT_BETWEEN: {
    NUMERIC: NumberInput
  },
  WITHIN_DISTANCE: {
    NUMERIC: NumberInput
  },
  NOT_WITHIN_DISTANCE: {
    NUMERIC: NumberInput
  },
  IS_BEFORE: {
    NUMERIC: NumberInput,
    DATETIME: DateInput,
    DATE: DateInput
  },
  IS_NOT_BEFORE: {
    NUMERIC: NumberInput,
    DATETIME: DateInput,
    DATE: DateInput
  },
  IS_AFTER: {
    NUMERIC: NumberInput,
    DATETIME: DateInput,
    DATE: DateInput
  },
  IS_NOT_AFTER: {
    NUMERIC: NumberInput,
    DATETIME: DateInput,
    DATE: DateInput
  },
  IS_BEFORE_RELATIVE: {
    NUMERIC: NumberInput
  },
  IS_AFTER_RELATIVE: {
    NUMERIC: NumberInput
  },
  HAS_OCCURRED_EXACTLY: {
    NUMERIC: NumberInput
  }
}

export const resolveComponentForOperator = (type, operator) => {
  const operatorOptions = PROPERTY_TYPE_COMPONENTS_BY_OPERATOR[operator]
  const overrideDefault = DATE_BASED_OPERATORS.includes(operator) ? PROPERTY_TYPE_COMPONENT_DEFAULTS.DATE : operatorOptions[type]

  if (overrideDefault) {
    return overrideDefault
  }

  return PROPERTY_TYPE_COMPONENT_DEFAULTS[type]
}
